import './Radio-df9a5c02.css';

var classes = {"Radio":"prc-Radio-Radio-Ly4MR"};

export { classes as default };
